module.exports = __webpack_public_path__ + "media/images/app/become-vendor/PlayIcon-6b98d5d4088cae256f5b0f7bf84d7f39.webp";